/**
 * 返回给定值的平方值
 * ========================================================================
 * @method easeInQuad
 * @param {Number} x
 * @returns {number}
 */
const easeInQuad = (x) => {
  return x * x
}

export default easeInQuad
